import { DependencyContainer } from '../../../DependencyContainer';
import { TroubleshootingWorkflow } from '../components/IssueResolution/types';
import {
  TestingWebhook,
  Webhook,
  WebhookStatus,
} from '../components/Webhook/types';

export default class ConfigurationService {
  constructor(private readonly factory: DependencyContainer) {}

  async getWebhooksListItems(partnerId: string): Promise<WebhookStatus[]> {
    const response = await this.factory.configurationClient.fetchWebhooks(
      partnerId,
    );
    return response.data;
  }

  async addWebhook(partnerId: string, webhook: Webhook): Promise<Webhook> {
    const response = await this.factory.configurationClient.addWebhook(
      partnerId,
      webhook,
    );
    return response.data;
  }

  async updateWebhook(
    partnerId: string,
    webhookId: string,
    webhook: Partial<Webhook>,
  ): Promise<Webhook> {
    const response = await this.factory.configurationClient.patchWebhook(
      partnerId,
      webhookId,
      webhook,
    );
    return response.data;
  }

  async deleteWebhook(partnerId: string, webhookId: string): Promise<Webhook> {
    const response = await this.factory.configurationClient.deleteWebhook(
      partnerId,
      webhookId,
    );
    return response.data;
  }

  async testWebhook(
    partnerId: string,
    webhook: TestingWebhook,
  ): Promise<WebhookStatus> {
    const response = await this.factory.configurationClient.testWebhook(
      partnerId,
      webhook,
    );
    return response.data;
  }

  async getTroubleshootingWorkflows(
    partnerId: string,
  ): Promise<TroubleshootingWorkflow[]> {
    const response = await this.factory.configurationClient.fetchTroubleshootingWorkflows(
      partnerId,
    );
    return response.data;
  }

  async updateTroubleshootingWorkflowStatus(
    partnerId: string,
    id: string,
    enabled: boolean,
  ) {
    const response = await this.factory.configurationClient.updateTroubleshootingWorkflowStatus(
      partnerId,
      id,
      enabled,
    );
    return response;
  }

  async getEmailLanguages(partnerId: string) {
    const response = await this.factory.configurationClient.getEmailLanguages(
      partnerId,
    );
    return response.data;
  }
}
